import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SectionType } from 'enums-lib';
import { ISection } from 'interfaces-lib';
import {
  CertificationSectionComponent
} from '../workflow-config/config/docmerge-section-list/certification-section/certification-section.component';
import { DocmergeTemplateSectionComponent } from '../workflow-config/config/docmerge-section-list/docmerge-template-section/docmerge-template-section.component';
import { FixedFileSectionComponent } from '../workflow-config/config/docmerge-section-list/fixed-file-section/fixed-file-section.component';
import { AttachmentSectionComponent } from './attachment-section/attachment-section.component';
import { DocxTemplateSectionComponent } from './docx-template-section/docx-template-section.component';
import { HtmlDocxTemplateSectionComponent } from './html-docx-template-section/html-docx-template-section.component';
import { MergeSectionComponent } from './merge-section/merge-section.component';
import { OutputFileNameComponent } from './output-file-name/output-file-name.component';
import { OutputFileTypeBuilder } from './output-file-type/output-file-type-builder';
import { SignatureOutputFileTypeBuilder } from './output-file-type/signature-output-file-type-builder';

export class SectionFormFactory {
  public static build(type: SectionType, section?: ISection): UntypedFormGroup {
    // all sections will contain all the ISection fields as controls
    const baseForm = this.buildBaseForm(type, section);

    if (type === SectionType.DocxTemplate) {
      DocxTemplateSectionComponent.buildForm(baseForm, section);
    } else if (type === SectionType.HtmlDocxTemplate) {
      HtmlDocxTemplateSectionComponent.buildForm(baseForm, section);
    } else if (type === SectionType.OutputFileName) {
      OutputFileNameComponent.buildForm(baseForm, section);
    } else if (type === SectionType.OutputFileType) {
      OutputFileTypeBuilder.buildForm(baseForm, section);
    } else if (type === SectionType.SignatureOutputFileType) {
      SignatureOutputFileTypeBuilder.buildForm(baseForm, section);
    } else if (type === SectionType.File) {
      AttachmentSectionComponent.buildForm(baseForm, section);
    } else if (type === SectionType.FixedFile) {
      FixedFileSectionComponent.buildForm(baseForm, section);
    } else if (type === SectionType.Merge) {
      MergeSectionComponent.buildForm(baseForm, section);
    } else if (type === SectionType.DocMergeTemplateSection) {
      DocmergeTemplateSectionComponent.buildForm(baseForm, section);
    } else if (type === SectionType.Certification) {
      CertificationSectionComponent.buildForm(baseForm, section);
    }

    return baseForm;
  }

  // NOTE: this was an idea to allow specific Section Components to map the FormGroup FormControls into a specific Section class - NOT USED
  // public static parse(formGroup: FormGroup): ISection {
  //   const sectionType = formGroup.get('type').value as SectionType;
  //   if (sectionType === SectionType.DocxTemplate)
  //     DocxTemplateSectionComponent.parseForm(formGroup);
  //   return null;
  // }

  private static buildBaseForm(type: SectionType, section?: ISection): UntypedFormGroup {
    return new UntypedFormGroup({
      id: new UntypedFormControl(section?.id),
      type: new UntypedFormControl(type),
      order: new UntypedFormControl(section?.order),
      model: new UntypedFormControl(), // tricksy
      config: new UntypedFormControl(section?.config),
      referenceId: new UntypedFormControl(section?.referenceId),
      displayName: new UntypedFormControl(section?.displayName),
      description: new UntypedFormControl(section?.description),
      sourceType: new UntypedFormControl(section?.sourceType),
      sourceValue: new UntypedFormControl(section?.sourceValue),
      required: new UntypedFormControl({ value: true, disabled: false }), // whether the section is required - no ui
    });
  }
}
